module.exports = __webpack_public_path__ + "img/Download_on_the_App_Store_Badge_NL_135x40.png";